export class AnalyticsTransportOptions {
    baseUrl: string;
    frequency: number;
    traceId: string;
}
